<template>
  <Row>
    <Col span="24">
      <!-- <div
        style="
          display: flex;
          width: 100%;
          background: linear-gradient(to bottom, #ffffff, #dddddd);
          margin-bottom: 20px;
        "
      >
        <img
          style="background: #02a0e7"
          src="../../../static/img/Buy/icon-home.png"
          alt="暂无照片"
        />
        <Breadcrumb style="margin: 10px 0 0 30px" separator=">">
          <BreadcrumbItem to="/">首页</BreadcrumbItem>
          <BreadcrumbItem to="/home/News">新闻资讯</BreadcrumbItem>
          <BreadcrumbItem>行业新闻</BreadcrumbItem>
        </Breadcrumb>
      </div> -->
      <div class="res_div">
        <p class="res_div_p">{{ title }}</p>
        <div class="res_div_div"></div>
        <div style="text-align: center">
          <span class="news_ul_div_div02_sp">
            发布时间：2020-10-24
          </span>
        </div>
        <div class="div_img01" v-for="(item, index) in img" :key="index">
          <span
            v-if="item.sp !== ''"
            :src="item.sp"
            style="
              font-size: 17px;
              font-weight: bold;
              color: #70a9f8;
              line-height: 34px;
            "
            >{{ item.sp }}</span
          >
          <p class="font_div">{{ item.p }}</p>
          <img v-if="item.imgUrl !== ''" :src="item.imgUrl" alt="暂无照片" />
          <img
            v-if="item.imgUrl02 !== ''"
            :src="item.imgUrl02"
            alt="暂无照片"
          />
          <img
            v-if="item.imgUrl03 !== ''"
            :src="item.imgUrl03"
            alt="暂无照片"
          />
          <img
            v-if="item.imgUrl04 !== ''"
            :src="item.imgUrl04"
            alt="暂无照片"
          />
          <img
            v-if="item.imgUrl05 !== ''"
            :src="item.imgUrl05"
            alt="暂无照片"
          />
        </div>
      </div>
    </Col>
  </Row>
</template>

<script>
export default {
  data() {
    return {
      title: "建筑业协会各位领导参观指导南秀科技产品",
      img: [
        {
          imgUrl: "../../../static/img/News/NewsFour/NewsFour01.jpg",
          imgUrl02: "../../../static/img/News/NewsFour/NewsFour02.jpg",
          imgUrl03: "../../../static/img/News/NewsFour/NewsFour03.jpg",
          imgUrl04: "../../../static/img/News/NewsFour/NewsFour05.jpg",
          imgUrl05: "../../../static/img/News/NewsFour/NewsFour06.jpg",
          sp: "消防VR安全体验",
          p:
            "体验者戴上VR眼镜后，仿佛身临其境，整个工地逼真地展示在眼前，似乎触手可及。让体验者有更加逼真的感受，可以直接体验高空坠落、洞口坠落、灭火器演示等体验效果。新兴VR科技体验激发了工人参加安全教育的兴趣，" +
            "工人对安全事故的感性认识也会增强很多。虚拟场景建设不受场地限制，可模拟真实场景下的安全事故。",
        },
        {
          imgUrl: "../../../static/img/News/NewsFour/NewsFour07.jpg",
          imgUrl02: "../../../static/img/News/NewsFour/NewsFour08.jpg",
          imgUrl03: "../../../static/img/News/NewsFour/NewsFour09.jpg",
          imgUrl04: "../../../static/img/News/NewsFour/NewsFour10.jpg",
          imgUrl05: "../../../static/img/News/NewsFour/NewsFour11.jpg",
          sp: "智能机器人",
          p:
            "在云端知识库存储政务服务、通用的专业、专属以及公共类回答。本地知识库可存储分行自有独特的回答。机器人听到问题后，会首先搜索本地知识库，如果在本地没有匹配回答，机器人就会搜索云端知识库，找到最优答案。云端知识库可安排人员进行更新、增加，使机器人变得越来越聪明。\n" +
            "云端专业回答：常见安全知识介绍、公司业务咨询、介公司政策解读、业务流程等知识;\n" +
            "云端专属回答：通过编辑的回答、企业文化、专有欢迎词等;\n" +
            "云端公共库回答：天气、新闻、百科全书等;\n" +
            "本地知识库回答：地理信息、人员介绍、特殊场景回答设定等;",
        },
        {
          imgUrl: "../../../static/img/News/NewsFour/NewsFour13.jpg",
          imgUrl02: "",
          imgUrl03: "",
          imgUrl04: "",
          imgUrl05: "",
          sp: "在线教育考试系统",
          p:
            "在线教育考试系统产品是入场人员信息录入，安全知识课件学习、安全知识考试、信息上传、培训数据监控平台、五大功能为一体的一对多人学习考试设备。" +
            "为企业解决了实名制登记问题，解决了安全知识集中学习无法评估的问题，解决了安全培训数据不真实问题，为企业解决安全教育培训无法监控的问题。",
        },
        {
          imgUrl: "../../../static/img/News/NewsFour/NewsFour17.jpg",
          imgUrl02: "../../../static/img/News/NewsFour/NewsFour18.jpg",
          imgUrl03: "../../../static/img/News/NewsFour/NewsFour19.jpg",
          imgUrl04: "",
          imgUrl05: "",
          sp: "三维立体展示平台",
          p:
            "三维立体展示平台是一款专为工程建设打造的，严格依照质量样板的设计要求。软件允许使用人员随时随地的查看各种工法质量样板，方便快捷。使用时，" +
            "只需通过手指触控屏幕，便可看到相对应的工法质量样板进行缩放。旋转。移动和分解演示等操作，方便使用者查看工程细部节点的施工工艺。",
        },
        {
          imgUrl: "../../../static/img/News/NewsFour/NewsFour20.jpg",
          imgUrl02: "",
          imgUrl03: "",
          imgUrl04: "",
          imgUrl05: "",
          sp: "互动台-电子沙盘",
          p:
            "我们通过电子沙盘党建馆定期对项目人员进行党建培训，多媒体党建展厅的展示可以让人民更直观的认识党的文化，领导人的英雄事迹。也是企业文化的向导，" +
            "培养人民形成党的价值观念、行为规范，为党风建设注入了新的源泉。在宣传和展示红色文化的同时，还要展示出对于新时期党建的意义，时代的进步性，展示党的付出和奉献精神。",
        },
        {
          imgUrl: "../../../static/img/News/NewsFour/NewsFour21.jpg",
          imgUrl02: "",
          imgUrl03: "",
          imgUrl04: "",
          imgUrl05: "",
          sp: "实测实量系统-数字蓝牙回弹仪 ",
          p:
            "智能回弹仪，将回弹仪重新开模利用轻量化，符合人体工程学的新设计思路，增加多种传感器内置新的计算单元和新的传输模块，同时保证使用便利性和易学性，降低使用门槛，" +
            "达到符合整个测量系统使用。操作方法同样是在软件内部选择智能回弹仪测量模式，进入界面后选择要使用的测量表格，输入常用规格方式，根据要求建立表格写入必备信息即可开始，" +
            "测量完成后根据需求可以选择直接导出或者上传服务器，以便于实测实量云数据平台上进行查阅或数据分析。",
        },
        {
          imgUrl: "../../../static/img/News/NewsFour/NewsFour22.jpg",
          imgUrl02: "",
          imgUrl03: "",
          imgUrl04: "",
          imgUrl05: "",
          sp: "实测实量系统-数字蓝牙靠尺 ",
          p:
            "智能靠尺系统通过新型智能靠尺硬件设备作为数据信息采集,配合移动智能设备APP软件进行数据整理归类计算并通过云数据存储平台进行持久化存储整理的一套完整的前端硬件设备+" +
            "中端APP软件+后端云服务器平台数据解决系统。可解决数据存储麻烦，保存困难的问题，并且有效进行数据管理，避免多测、少测和重复测量，以此来达到规范化,精细化，" +
            "和自动化测量智能化施工的效果。极大的提高测量效率，减少工人工作量，加快整个工程施工进度，同时可以更加规范化，精细化和科学化施工。",
        },
      ],
    };
  },
  mounted() {
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  },
  methods: {
    getUnderStandMore() {
      this.$router.push({
        name: "AR",
      });
    },
  },
};
</script>

<style scoped>
.res_div img {
  width: 100%;
  margin: 10px 0;
}

.res_div_p {
  font-size: 30px;
  font-weight: bold;
  color: #000;
}

.font_div {
  font-size: 16px;
  line-height: 26px;
  margin-bottom: 10px;
}

.res_div_div {
  border-bottom: 1px dashed #e1e1e1;
  margin: 10px 0;
}

.news_ul_div_div02_sp {
  font-size: 12px;
  color: #888;
  line-height: 30px;
}

.div_img01 img {
  width: 96%;
  margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/News/NewsFour.vue